import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../baseQuery";

export interface Messagerie {
  _id?: string,
  msg: string,
  sender: string,
  receiver: string,
  date: string,
  heure: string,
  fichier_base64_string: string[],
  fichier_extension: string[],
  fichiers: string[],
}

export interface MessagerieCollectif {
  _id?: string,
  msg: string,
  sender: string,
  receivers: string[],
  date: string,
  heure: string,
  fichier_base64_string: string[],
  fichier_extension: string[],
  fichiers: string[],
}

export const messagerieSlice = createApi({
  reducerPath: "Messagerie",
  baseQuery: baseQueryWithAuth("messages"),
  tagTypes: ["Messagerie"],
  endpoints(builder) {
    return {
        getMessageries: builder.query<Messagerie[], number | void>({
        query() {
          return `/getMessageries`;
        },
        providesTags: ["Messagerie"],
      }),
      getMessageriesByParentId: builder.mutation<Messagerie[], string | void>({
        query: (id) => ({
          url: `/messagesByParent/${id}`,
          method: "GET",
        }),
        invalidatesTags: ["Messagerie"],
      }),
      newMessagerie: builder.mutation<void, Messagerie>({
        query(payload) {
          return {
            url: "/newMessagerie",
            method: "POST",
            body: payload,
          };
        },
        invalidatesTags: ["Messagerie"],
      }),
      newMessagerieCollectif: builder.mutation<void, MessagerieCollectif>({
        query(payload) {
          return {
            url: "/newMessagerieCollectif",
            method: "POST",
            body: payload,
          };
        },
        invalidatesTags: ["Messagerie"],
      }),
      deleteMessagerie: builder.mutation<void, Messagerie>({
        query: (_id) => ({
          url: `/deleteMessagerie/${_id}`,
          method: "Delete",
        }),
        invalidatesTags: ["Messagerie"],
      }),
    };
  },
});

export const {
 useDeleteMessagerieMutation,
 useGetMessageriesQuery,
 useNewMessagerieMutation,
 useGetMessageriesByParentIdMutation,
 useNewMessagerieCollectifMutation
} = messagerieSlice;